import React from 'react'

// Redux
import { connect } from 'react-redux'

// Firebase
import * as firebase from 'firebase';
import { DataLoader } from '@fibo-app/fibo-collab-shared';

class FirebaseChatsManager extends React.Component {

  roomMetadataLoaders : { [string]: DataLoader }
  roomMembersLoaders : { [string]: DataLoader }
  roomMessagesLoaders : { [string]: DataLoader }

  constructor(props : Object) {
    super(props);

    this.roomMetadataLoaders = {}
    this.roomMembersLoaders = {}
    this.roomMessagesLoaders = {}

    this.checkRooms(undefined, props.userRooms);
  }

  componentWillReceiveProps(nextProps) {
    this.checkRooms(this.props.userRooms, nextProps.userRooms);
  }

  checkRooms(currUserRooms, nextUserRooms) {
    const oldRooms = [];
    const newRooms = [];

    // Detect the changes (new & old rooms)
    const nextRoomIds = this.getRoomIds(nextUserRooms);
    const currRoomIds = this.getRoomIds(currUserRooms);
    for (const key in nextRoomIds) {
      if (!currRoomIds[key]) {
        newRooms.push(key);
      }
    }
    for (const key in currRoomIds) {
      if (!nextRoomIds[key]) {
        oldRooms.push(key);
      }
    }

    // Start syncing new rooms and stop syncing old rooms
    for (let i = 0; i < oldRooms.length; i++) {
      this.stopSyncingRoom(oldRooms[i]);
    }
    for (let i = 0; i < newRooms.length; i++) {
      this.startSyncingRoom(newRooms[i]);
    }
  }

  startSyncingRoom(roomId : string) {
    const roomMetadataLoader = new DataLoader(firebase, 'rooms', 'metadata');
    this.props.dispatch(roomMetadataLoader.startSyncing(roomId));
    this.roomMetadataLoaders[roomId] = roomMetadataLoader;

    const roomMembersLoader = new DataLoader(firebase, 'rooms', 'members');
    this.props.dispatch(roomMembersLoader.startSyncing(roomId));
    this.roomMembersLoaders[roomId] = roomMembersLoader;

    const roomMessagesLoader = new DataLoader(firebase, 'rooms', 'messages', true);
    this.props.dispatch(roomMessagesLoader.startSyncing(roomId));
    this.roomMessagesLoaders[roomId] = roomMessagesLoader;
  }

  stopSyncingRoom(roomId) {
    if (this.roomMetadataLoaders.hasOwnProperty(roomId)) {
      this.roomMetadataLoaders[roomId].stopSyncing();
      delete this.roomMetadataLoaders[roomId];
    }

    if (this.roomMembersLoaders.hasOwnProperty(roomId)) {
      this.roomMembersLoaders[roomId].stopSyncing();
      delete this.roomMembersLoaders[roomId];
    }

    if (this.roomMessagesLoaders.hasOwnProperty(roomId)) {
      this.roomMessagesLoaders[roomId].stopSyncing();
      delete this.roomMessagesLoaders[roomId];
    }
  }

  getRoomIds(userRooms) {
    const result = {};
    if (!userRooms || userRooms.loading) {
      return result;
    }

    for (let i = 0; i < userRooms.value.length; i++) {
      result[userRooms.value[i].dbKey] = true;
    }
    return result;
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    userRooms: state.firebase.user.rooms,
  }
};
export default connect(mapStateToProps)(FirebaseChatsManager)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseChatsManager.js